module.exports = __webpack_public_path__ + "static/img/google_permission.82f3cb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/google_permission.png
// module id = 0irA
// module chunks = 4